var map = {
	"./0.1.0/reference.json": 108,
	"./0.10.0/reference.json": 107,
	"./0.14.0/reference.json": 106,
	"./0.15.0/reference.json": 105,
	"./0.16.0/reference.json": 104,
	"./0.17.0/reference.json": 103,
	"./0.18.0/reference.json": 102,
	"./0.19.0/reference.json": 101,
	"./0.2.0/reference.json": 100,
	"./0.20.0/reference.json": 99,
	"./0.21.0/reference.json": 98,
	"./0.22.0/reference.json": 97,
	"./0.23.0/reference.json": 96,
	"./0.26.0/reference.json": 95,
	"./0.27.0/reference.json": 94,
	"./0.29.0/reference.json": 93,
	"./0.3.0/reference.json": 92,
	"./0.33.0/reference.json": 91,
	"./0.34.0/reference.json": 90,
	"./0.37.0/reference.json": 89,
	"./0.37.1/reference.json": 88,
	"./0.38.0/reference.json": 87,
	"./0.4.0/reference.json": 86,
	"./0.40.0/reference.json": 85,
	"./0.41.0/reference.json": 84,
	"./0.43.0/reference.json": 83,
	"./0.44.0/reference.json": 82,
	"./0.47.0/reference.json": 81,
	"./0.51.0/reference.json": 80,
	"./0.52.0/reference.json": 79,
	"./0.54.0/reference.json": 78,
	"./0.55.0/reference.json": 77,
	"./0.55.1/reference.json": 76,
	"./0.58.1/reference.json": 75,
	"./0.59.3/reference.json": 74,
	"./0.59.4/reference.json": 73,
	"./0.6.0/reference.json": 72,
	"./0.7.0/reference.json": 71,
	"./0.9.0/reference.json": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;